import styled from 'styled-components';

interface ContainerProps {
  background: string;
}

export const Container = styled.div<ContainerProps>`
  position: relative;

  & > div {
    background-color: ${(props) =>
      props.background === 'bg-light' ? 'white' : props.theme.$gray200};
  }

  .breakdown-trigger {
    cursor: default;
  }

  .breakdown-popover {
    position: absolute;
    top: calc(100% - 0.75rem);
    left: 1.5rem;
    z-index: 20;
  }
  p {
    font-weight: 600;
    font-size: 16px;
  }
`;
